export default __webpack_public_path__ + "static/media/suuRed.3e6bab4f.svg";